import { render, staticRenderFns } from "./UserSessionsTable.vue?vue&type=template&id=53687494&"
import script from "./UserSessionsTable.vue?vue&type=script&lang=js&"
export * from "./UserSessionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports